import React from 'react';
import { US_STATES } from 'woop-shared/data/states';
import SelectField from './SelectField';

const USStateSelect = props => {
  return <SelectField options={US_STATES} {...props} />;
};

export default USStateSelect;
